// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL,
  UPDATE_HISTORY,
  VALIDATE_LOAN_CONTROL
} from '@/graphql/dailyControl/LoanControlGraphql'

// models
import { ResponseDefault, Paginator, ResponseCustom } from '@/models'
import {
  LoanControlModel,
  LoanControlsWithPagination,
  LoanControlForm,
  FiltersLoanControl,
  HistoryLoanControlInput
} from '@/models/dailyControl'

// apollo
import { apolloClient } from '@/apollo'
import { getFirstErrorApollo } from '@/utils/apollo'

const filtersDefault: FiltersLoanControl = {
    dateStart: null,
    employee: null,
    frequency: null,
    loanDate: null,
    status: null
}

class LoanControlsService {
  /**
   * Queries
   */
  async getWithPagination (perPage = 10, page = 1, filters: FiltersLoanControl): Promise<LoanControlsWithPagination> {
      const result = await apolloClient.query({
          query: GET_WITH_PAGINATION,
          variables: {
            page: page,
            perPage: perPage,
            filters: {
                ...filters,
                employee: filters.employee ? Number(filters.employee) : null,
                frequency: filters.frequency == null ? null : Number(filters.frequency),
                status: filters.status == null ? null : Number(filters.status)
            }
          }
      })
      const pagination: Paginator = result.data.loanControlsWithPagination.paginatorInfo
      const data: LoanControlModel[] = result.data.loanControlsWithPagination.data
      const response: LoanControlsWithPagination = {
          objects: data,
          pagination: pagination
      }
      return response
  }

    async getAll (filters: FiltersLoanControl = filtersDefault): Promise<LoanControlModel[]> {
        const result = await apolloClient.query({
            query: GET_ALL,
            variables: {
                filters: {
                    ...filters,
                    employee: filters.employee ? Number(filters.employee) : null,
                    frequency: filters.frequency == null ? null : Number(filters.frequency),
                    status: filters.status == null ? null : Number(filters.status)
                }
            }
        })
        return result.data.loanControls
    }

  /**
   * Mutations
   */
    create (form: LoanControlForm): Promise<ResponseCustom> {
        return apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        }).then(() => {
            return {
                success: true,
                msg: 'success'
            }
        }).catch(e => {
            throw getFirstErrorApollo(e)
        })
    }

  update (id: number, form: LoanControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
        mutation: UPDATE,
        variables: {
            id: id,
            input: form
        }
    }).then(() => {
        return {
            success: true,
            msg: 'success'
        }
    }).catch(e => {
        throw getFirstErrorApollo(e)
    })
  }

  updateHistory (id: number, form: HistoryLoanControlInput): Promise<ResponseCustom> {
    return apolloClient.mutate({
        mutation: UPDATE_HISTORY,
        variables: {
            id: id,
            input: form
        }
    }).then(() => {
        return {
            success: true,
            msg: 'success'
        }
    }).catch(e => {
        throw getFirstErrorApollo(e)
    })
  }

  async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
  }

  validateExists (id: number|null, form: LoanControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
        mutation: VALIDATE_LOAN_CONTROL,
        variables: {
            id: id,
            input: form
        }
    }).then(res => {
        return {
            success: res.data.validateLoanControl.success,
            msg: res.data.validateLoanControl.msgError
        }
    }).catch(e => {
        throw getFirstErrorApollo(e)
    })
  }
}

export default new LoanControlsService()
